import { AvaliacaoOrdemCompra } from "../../../../compras/domain/models/avaliacao_ordem_compra";
import { IGetAvaliacaoFornecedorUseCase } from "../../../presentation/useCases/read/get_ordem_compra_avaliacao_fornecedor_use_case";
import { AvaliacaoOrdemFornecimento } from "../../models/avaliacao_ordem_compra";
import { ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

/**
 * GetAvaliacaoFornecedorUseCase
 */

export class GetAvaliacaoFornecedorUseCase implements IGetAvaliacaoFornecedorUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) { }

  async getAvaliacaoFornecedor(
    IdMedicaoTerceirizacao: number | null,
  ): Promise<AvaliacaoOrdemFornecimento> {
    const result = await this.repository.getAvaliacaoFornecedor(IdMedicaoTerceirizacao);
    if (result === null) throw new Error('Falha ao buscar avaliaçãa!');
    return result;
  }
}
